import {EventRow} from "./event-row";

export class MonthRow<T> {
  isOpen: boolean = false;
  name: string="";
  eventEntries: EventRow<T>[] = [];
  monthRevenue: number = 0;
}
